import { SVGProps, Ref, forwardRef } from 'react';

export const OneCBrandSize16Glyph = forwardRef((props: SVGProps<SVGSVGElement>, ref: Ref<SVGSVGElement>) => (
    <svg width={16} height={16} viewBox="0 0 16 16" fill="none" xmlns="http://www.w3.org/2000/svg" ref={ref} {...props}>
        <path
            d="M8.226 4.127c2.132 0 3.868 1.713 3.89 3.827h-1.033a2.853 2.853 0 0 0-2.857-2.801 2.853 2.853 0 0 0-2.858 2.84 2.84 2.84 0 0 0 1.66 2.578c.057.025.274.105.328.12.28.081.637.135.947.155.091.007.504.01.598.01H16v1.023H8.89c-.132-.001-.58-.006-.71-.015a6 6 0 0 1-1.152-.2 5 5 0 0 1-.642-.268 3.86 3.86 0 0 1-2.05-3.402c0-2.132 1.745-3.867 3.89-3.867"
            fill="#D91920"
        />
        <path d="M2.14 11.875h-.999v-5.21H0V5.67h2.14z" fill="#D91920" />
        <path d="M3.7 11.875H2.66v-6.72H1.141V4.12H3.7z" fill="#D91920" />
        <path
            d="M8.226 5.784c1.214 0 2.2.968 2.22 2.17h-.99a1.23 1.23 0 0 0-1.23-1.184c-.68 0-1.23.548-1.23 1.224 0 .465.261.867.645 1.074.054.03.176.076.305.11.114.026.292.044.415.055.073.006.466.008.54.008H16v.987H8.872c-.086-.002-.487-.005-.57-.011a4.3 4.3 0 0 1-.7-.107 2.205 2.205 0 0 1-1.6-2.117c0-1.22.996-2.209 2.224-2.209"
            fill="#D91920"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.222 4.528c.066 0 .223.022.223.195 0 .043-.01.113-.118.15.086.028.097.098.097.173.01.103 0 .124.026.151h-.123c-.028-.016-.028-.037-.028-.151 0-.059-.011-.124-.152-.124h-.099v.275h-.124v-.67zm-.174.086v.211h.147c.104 0 .126-.06.126-.102 0-.082-.06-.11-.147-.11z"
            fill="#D91920"
        />
        <path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M14.163 4.193a.67.67 0 0 1 .684.67.68.68 0 0 1-.684.68.687.687 0 0 1-.685-.68c0-.373.31-.67.685-.67m0 .108a.573.573 0 0 0-.576.562c0 .328.267.571.576.571a.57.57 0 0 0 .575-.571.57.57 0 0 0-.575-.562"
            fill="#D91920"
        />
    </svg>
));
OneCBrandSize16Glyph.displayName = 'OneCBrandSize16Glyph';
